import { getRegisterFunction } from '../../utils/register.js';
import { OneUxMenuElement } from './OneUxMenuElement.js';
export const register = getRegisterFunction(OneUxMenuElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-menu': OneUxMenuElement;
    "menu-ddbf6a107db77687982d1172eec9b762": OneUxMenuElement;
  }
}